import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface HeartRoundIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const HeartRoundIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: HeartRoundIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12.0028 19.1829C14.4507 19.1829 18.1794 13.9424 18.8712 12.9336C20.7015 10.7312 20.7363 8.0834 18.9614 6.18172C18.1577 5.32215 17.037 4.82911 15.8603 4.81758C14.6337 4.79919 13.4515 5.27687 12.5818 6.14226C12.428 6.29552 12.2198 6.38167 12.0028 6.38167C11.7857 6.38167 11.5775 6.29552 11.4237 6.14226C10.5724 5.29552 9.42104 4.81937 8.2203 4.81758H8.14456C6.96783 4.82913 5.84716 5.32215 5.04342 6.18172C3.26848 8.0809 3.30031 10.7289 5.10254 12.8917C5.82622 13.9421 9.55483 19.1826 12.0028 19.1826L12.0028 19.1829ZM5.87488 6.95798C6.4689 6.3245 7.29661 5.9619 8.16508 5.95466H8.2204C9.11992 5.9558 9.98267 6.31232 10.6206 6.94668C10.9874 7.31282 11.4846 7.51848 12.0029 7.51848C12.5211 7.51848 13.0184 7.31282 13.3852 6.94668C14.0381 6.30089 14.9225 5.94361 15.8407 5.95466C16.7091 5.96189 17.5368 6.3245 18.1309 6.95798C19.5329 8.45776 19.4821 10.42 17.9649 12.2486C16.4234 14.4895 13.4412 18.0462 12.003 18.0462C10.5648 18.0462 7.58317 14.4897 6.00986 12.2067C4.52366 10.4198 4.47293 8.45756 5.87499 6.95766L5.87488 6.95798Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default HeartRoundIcon
